import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    datas: [],
    totalCount: 0,
    detail: null,
    coinTypes: []
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item
      }));
    }
  },
  mutations: {
    setList(state, payload) {
      // state.datas = payload;
      state.datas = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetail(state, payload) {
      state.detail = payload;
    }
  },
  actions: {
    reqList({ commit }, query) {
      api.reqList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypes({ commit }) {
      api.getCoinTypes().then(({ data }) => {
        commit('setCoinTypes', data);
      });
    }
    // remove(context, data) {
    //   return api.remove(data);
    // }
  }
};

appStore.registerModule('pledgeInterest', store);
